import React from 'react'
import { Switch, Route, Link } from 'react-router-dom'

import Breadcrumbs from '@/Layout/Breadcrumbs'
import PageTitle from '@/Layout/PageTitle'

import FeedbackIndex from '@/pages/Feedback/FeedbackIndex'
import FeedbackShow from '@/pages/Feedback/FeedbackShow'
import FeedbackNew from '@/pages/Feedback/FeedbackNew'

export default function FeedbackContainer(props) {
  const crumbs = [{ to: '/feedback', name: 'Feedback' }]

  return <>
    <Breadcrumbs>
      {crumbs.map((crumb, index) => (
        <Link key={`${index}${crumb.name}`} to={crumb.to} className='text-xs sm:text-sm text-gray-500 hover:text-gray-700 dark:text-gray-100'>
          {crumb.name}
        </Link>
      ))}
    </Breadcrumbs>
    <PageTitle pagetitle='Feedback'>{[]}</PageTitle>
    <Switch>
      <Route {...props} exact path='/feedback/new'>
        <FeedbackNew />
      </Route>
      <Route {...props} exact path='/feedback/:slug'>
        <FeedbackShow />
      </Route>
      <Route {...props} exact path='/feedback'>
        <FeedbackIndex />
      </Route>
    </Switch>
  </>
}
